import { Component } from '@angular/core';
import { AuthenticationService, UserService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ selector: 'settings-and-support', templateUrl: 'settings.component.html' })
export class SettingsComponent {
    subscriptionStatus = "subscribed";

    constructor(private userService: UserService,
        private authService: AuthenticationService) {}

    ngOnInit() {
        this.userService.getMailSubscriptionStatus().pipe(first()).subscribe(data => {
            this.subscriptionStatus = data.status;
        });
    }

    changeSubscriptionStatus() {
        let userId = this.authService.currentUserValue.id;
        this.userService.setMailUpdates(userId, this.subscriptionStatus != 'subscribed').pipe(first()).subscribe(data => {
            this.subscriptionStatus = data.status;
        });
    }
}